import Axios from "./config";

class Exhibits {
  /**
   *
   */
  getRecentUpdates() {
    return Axios.get("/exhibits/recent");
  }

  /**
   *
   * @param {*} formData
   */
  manageExhibit(formData) {
    const { id } = formData;

    if (id === "") {
      return Axios.post("/exhibits", formData);
    }

    return Axios.put("/exhibits", formData);
  }

  /**
   *
   * @param {*} id
   */
  getDetails(id) {
    return Axios.get(`/exhibits/${id}/details`);
  }

  /**
   *
   * @param {*} id
   */
  deleteExhibit(id) {
    return Axios.delete(`/exhibits/${id}`);
  }

  /**
   *
   * @param {*} criteria
   */
  search(criteria) {
    return Axios.get(`/exhibits/search?criteria=${criteria}`);
  }

  /**
   *
   * @param {*} exhibitID
   */
  getArtifacts(exhibitID) {
    return Axios.get(`/exhibits/${exhibitID}/artifacts`);
  }
}

export default new Exhibits();



// WEBPACK FOOTER //
// ./src/api/exhibits.js